<section appReveal class="ts-section w-full px-4 sm:px-8" [class.ts-center]="layout === 'center'">
    <div class="ts-inner mx-auto flex w-full max-w-[1200px] flex-col">

        @if (layout === 'center') {
            <!-- Centered header. -->
            <div class="ts-head-center flex w-full flex-col items-center text-center">
                <h2 class="ts-heading font-outfit font-bold" [innerHTML]="section.headingHtml"></h2>
                @if (bodyLead.length) {
                    <div class="ts-prose font-inter space-y-4 mt-5">
                        @for (paragraph of bodyLead; track $index) {
                            <p>{{ paragraph }}</p>
                        }
                    </div>
                }
            </div>
        } @else {
            <!-- Split header: heading left, body copy right (stacks on mobile). -->
            <div class="ts-head grid w-full gap-6 lg:grid-cols-2 lg:gap-12">
                @if (link) {
                    <a [routerLink]="link" class="ts-heading-link">
                        <h2 class="ts-heading font-outfit font-bold" [innerHTML]="section.headingHtml"></h2>
                    </a>
                } @else {
                    <h2 class="ts-heading font-outfit font-bold" [innerHTML]="section.headingHtml"></h2>
                }
                @if (bodyLead.length) {
                    <div class="ts-prose font-inter space-y-4">
                        @for (paragraph of bodyLead; track $index) {
                            <p>{{ paragraph }}</p>
                        }
                    </div>
                }
            </div>
        }

        <p class="ts-eyebrow r-up font-outfit font-bold mt-14 text-center">{{ eyebrow }}</p>

        @if (section.bullets?.length) {
            <ul class="ts-tags mt-10 flex w-full flex-wrap justify-center gap-4">
                @for (bullet of section.bullets; track $index) {
                    <li class="ts-tag r-scale" [style.--reveal-delay]="$index * 70 + 'ms'">
                        @if (marker === 'check') {
                            <span class="ts-check" aria-hidden="true">
                                <img src="images/shared/check.svg" alt="" loading="lazy" />
                            </span>
                        } @else {
                            <span class="ts-dot" aria-hidden="true"></span>
                        }
                        <span class="ts-tag-label">{{ bullet }}</span>
                    </li>
                }
            </ul>
        }

        @if (section.outro?.length) {
            <div class="ts-outro font-inter space-y-4 mt-12">
                @for (paragraph of section.outro; track $index) {
                    <p>{{ paragraph }}</p>
                }
            </div>
        }
    </div>
</section>
